import { Guid } from "@/Common/Models/Guid";
import { MedicalRequestType } from "@/Common/Models/MedicalRequest/Enum/MedicalRequestType";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent, ServerEventWithRequest } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { PatientMedicalSummaryHelper } from "@/Patient/Helpers/PatientMedicalSummaryHelper";
import { MedicalItemSubtypeEnum } from "@/Patient/Models/MedicalSummary/Enum/MedicalItemSubTypeEnum";
import { MedicalItemTypeEnum } from "@/Patient/Models/MedicalSummary/Enum/MedicalItemTypeEnum";
import { MedicalItem } from "@/Patient/Models/MedicalSummary/MedicalItem";
import { MedicalItemAlertsAndSpecialNeeds } from "@/Patient/Models/MedicalSummary/MedicalItemAlertsAndAllergies";
import { MedicalItemFamilyHistory } from "@/Patient/Models/MedicalSummary/MedicalItemFamilyHistory";
import { MedicalItemImmunization } from "@/Patient/Models/MedicalSummary/MedicalItemImmunization";
import { MedicalItemMedicalReaction } from "@/Patient/Models/MedicalSummary/MedicalItemMedicalReaction";
import { MedicalItemMedicationAndPrescription } from "@/Patient/Models/MedicalSummary/MedicalItemMedicationAndPrescription";
import { MedicalItemProblemAndCondition } from "@/Patient/Models/MedicalSummary/MedicalItemProblemAndCondition";
import { MedicalItemRiskFactor } from "@/Patient/Models/MedicalSummary/MedicalItemRiskFactor";
import { MedicalItemVitalSign } from "@/Patient/Models/MedicalSummary/MedicalItemVitalSign";
import { FollowUpResponse } from "@/Patient/Models/MedicalSummary/Response/FollowUpResponse";
import { MedicalItemScreeningTestResponse } from "@/Patient/Models/MedicalSummary/Response/MedicalItemScreeningTestResponse";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";
import { IPatientMedicalSummaryModel } from "@/Patient/Models/UI/MedicalSummary/IPatientMedicalSummaryModel";
import { PatientStore } from "@/Patient/Stores/PatientStore";

interface INoteSwapFunction {
    (updatesItems: MedicalItem[], notesModel: IPatientMedicalNoteModel): IPatientMedicalNoteModel
}

interface ISummarySwapFunction {
    (summaryModel: IPatientMedicalSummaryModel): IPatientMedicalSummaryModel
}

class PatientMedicalItemsResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemProblem, this.saveMedicalItemProblem, SubServerOperations.MedicalItems.SaveMedicalItems);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemProblem, this.SaveMedicalItemProblemPlus, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemProblem, this.SaveMedicalItemInNewEncounter, SubServerOperations.MedicalItems.SaveInNewEncounter);

        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemMedicalReaction, this.SaveMedicalItemMedicalReaction, SubServerOperations.MedicalItems.SaveMedicalItems);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemMedicalReaction, this.SaveMedicalItemMedicalReactionPlus, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemMedicalReaction, this.SaveMedicalItemInNewEncounter, SubServerOperations.MedicalItems.SaveInNewEncounter);

        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemRiskFactor, this.SaveMedicalItemRiskFactor, SubServerOperations.MedicalItems.SaveMedicalItems);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemRiskFactor, this.SaveMedicalItemRiskFactorPlus, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemRiskFactor, this.SaveMedicalItemInNewEncounter, SubServerOperations.MedicalItems.SaveInNewEncounter);

        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemAlert, this.SaveMedicalItemAlert, SubServerOperations.MedicalItems.SaveMedicalItems);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemAlert, this.SaveMedicalItemAlertPlus, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemAlert, this.SaveMedicalItemInNewEncounter, SubServerOperations.MedicalItems.SaveInNewEncounter);

        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemFamilyHistory, this.SaveMedicalItemFamilyHistory, SubServerOperations.MedicalItems.SaveMedicalItems);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemFamilyHistory, this.SaveMedicalItemFamilyHistoryPlus, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemFamilyHistory, this.SaveMedicalItemInNewEncounter, SubServerOperations.MedicalItems.SaveInNewEncounter);

        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemImmunization, this.SaveMedicalItemImmunization, SubServerOperations.MedicalItems.SaveMedicalItems);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemImmunization, this.SaveMedicalItemImmunizationPlus, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemImmunization, this.SaveMedicalItemInNewEncounter, SubServerOperations.MedicalItems.SaveInNewEncounter);

        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemVitalSign, this.SaveMedicalItemVitalSign, SubServerOperations.MedicalItems.SaveMedicalItems);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemVitalSign, this.SaveMedicalItemVitalSignPlus, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemVitalSign, this.SaveMedicalItemInNewEncounter, SubServerOperations.MedicalItems.SaveInNewEncounter);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_EMRTemplate_Get, this.loadVitalSigns, SubServerOperations.Patient.AllVitals);

        this.RegisterOperation(ServerOperations.Server.Myle_UpsertMedication, this.SaveMedicalItemActiveMedication, SubServerOperations.MedicalItems.SaveMedicalItems);
        this.RegisterOperation(ServerOperations.Server.Myle_UpsertMedication, this.SaveMedicalItemActiveMedicationPlus, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
        this.RegisterOperation(ServerOperations.Server.Myle_UpsertMedication, this.SaveMedicalItemInNewEncounter, SubServerOperations.MedicalItems.SaveInNewEncounter);

        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemScreeningTest, this.SaveMedicalItemScreeningTest, SubServerOperations.MedicalItems.SaveMedicalItems);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemScreeningTest, this.SaveMedicalItemScreeningTestPlus, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemScreeningTest, this.SaveMedicalItemInNewEncounter, SubServerOperations.MedicalItems.SaveInNewEncounter);

        this.RegisterOperation(ServerOperations.Server.Myle_Patient_MedicalItem_DeleteMedicalItem, this.DeleteMedicalItem);

        this.RegisterOperation(ServerOperations.Server.Myle_MedicalRequest_UpdateStatus, this.handleFollowupStatusUpdated);
    }

    // ---  Save [+} -----
    private SaveMedicalItemProblemPlus(response: ServerEvent, store: PatientStore): void {
        this.saveMedicalItemProblem(response, store, true);
    }

    private SaveMedicalItemMedicalReactionPlus(response: ServerEvent, store: PatientStore): void {
        this.SaveMedicalItemMedicalReaction(response, store, true);
    }

    private SaveMedicalItemRiskFactorPlus(response: ServerEvent, store: PatientStore): void {
        this.SaveMedicalItemRiskFactor(response, store, true);
    }

    private SaveMedicalItemAlertPlus(response: ServerEvent, store: PatientStore): void {
        this.SaveMedicalItemAlert(response, store, true);
    }

    private SaveMedicalItemActiveMedicationPlus(response: ServerEvent, store: PatientStore): void {
        this.SaveMedicalItemActiveMedication(response, store, true);
    }

    private SaveMedicalItemFamilyHistoryPlus(response: ServerEvent, store: PatientStore): void {
        this.SaveMedicalItemFamilyHistory(response, store, true);
    }

    private SaveMedicalItemImmunizationPlus(response: ServerEvent, store: PatientStore): void {
        this.SaveMedicalItemImmunization(response, store, true);
    }

    private SaveMedicalItemVitalSignPlus(response: ServerEvent, store: PatientStore): void {
        this.SaveMedicalItemVitalSign(response, store, true);
    }

    private SaveMedicalItemScreeningTestPlus(response: ServerEvent, store: PatientStore): void {
        this.SaveMedicalItemScreeningTest(response, store, true);
    }
    // ----------------------------

    // --- common -----
    private saveMedicalItemProblem(response: ServerEvent, store: PatientStore, isSavePlus: boolean = false): void {
        let patientNoteSwapFunction: INoteSwapFunction = function(updatedItems: MedicalItemProblemAndCondition[], notesModel: IPatientMedicalNoteModel): IPatientMedicalNoteModel {
            notesModel = notesModel.set("MedicalItemsProblemsAndDiagnostics", Immutable.List(updatedItems));
            return notesModel;
        };

        let summarySwapFunction: ISummarySwapFunction = function(summaryModel: IPatientMedicalSummaryModel): IPatientMedicalSummaryModel {
            let updatedMedicalItems: MedicalItemProblemAndCondition[] = response.Data.MedicalItems;
            let resolvedStatusLookup = cacheStore.FindLookupByLookupCode("RESOLVED", "PROBLEMSTATUS");

            let history = updatedMedicalItems.filter(x => (x.EMRTemplateMedicalItemSubType == null && x.ProblemStatusLookupId == resolvedStatusLookup.LookupID)
                || x.EMRTemplateMedicalItemSubType == MedicalItemSubtypeEnum.ProblemAndCondition_Past
            );

            summaryModel = summaryModel.set("MedicalItemsProblemsHistory", Immutable.List(history));

            let surgery = updatedMedicalItems.filter(x => x.EMRTemplateMedicalItemSubType == MedicalItemSubtypeEnum.ProblemAndCondition_SurgicalPast);
            summaryModel = summaryModel.set("MedicalItemsSurgeryHistory", Immutable.List(surgery));

            let psy = updatedMedicalItems.filter(x => x.EMRTemplateMedicalItemSubType == MedicalItemSubtypeEnum.ProblemAndCondition_Psychiatric);
            summaryModel = summaryModel.set("MedicalItemsPsychiatricHistory", Immutable.List(psy));

            let gyneco = updatedMedicalItems.filter(x => x.EMRTemplateMedicalItemSubType == MedicalItemSubtypeEnum.ProblemAndCondition_Gynecology);
            summaryModel = summaryModel.set("MedicalItemsGynecologicalHistory", Immutable.List(gyneco));

            let onGoing = updatedMedicalItems.filter(x => (x.EMRTemplateMedicalItemSubType == null && x.ProblemStatusLookupId !== resolvedStatusLookup.LookupID)
                || x.EMRTemplateMedicalItemSubType == MedicalItemSubtypeEnum.ProblemAndCondition_Ongoing
            );
            summaryModel = summaryModel.set("MedicalItemsProblemsOnGoing", Immutable.List(onGoing));

            return summaryModel;
        };

        this.saveMedicalItem(response, store, patientNoteSwapFunction, summarySwapFunction, MedicalItemTypeEnum.PastAndOngoingProblemsAndConditions, isSavePlus);
        cacheStore.refreshFavoriteDiagnoses();
        this.redirectToSummary(isSavePlus);
    }

    private SaveMedicalItemMedicalReaction(response: ServerEvent, store: PatientStore, isSavePlus: boolean = false): void {
        let patientNoteSwapFunction: INoteSwapFunction = function(updatedItems: MedicalItemMedicalReaction[], notesModel: IPatientMedicalNoteModel): IPatientMedicalNoteModel {
            notesModel = notesModel.set("MedicalItemsMedicalReaction", Immutable.List(updatedItems));
            return notesModel;
        };

        let summarySwapFunction: ISummarySwapFunction = function(summaryModel: IPatientMedicalSummaryModel): IPatientMedicalSummaryModel {
            let updatedMedicalItems: MedicalItemMedicalReaction[] = response.Data.MedicalItems;
            summaryModel = summaryModel.set("MedicalItemsMedicalReaction", Immutable.List(updatedMedicalItems));
            return summaryModel;
        };

        this.saveMedicalItem(response, store, patientNoteSwapFunction, summarySwapFunction, MedicalItemTypeEnum.MedicalReaction, isSavePlus);
        this.redirectToSummary(isSavePlus);
    }

    private SaveMedicalItemRiskFactor(response: ServerEvent, store: PatientStore, isSavePlus: boolean = false): void {
        let patientNoteSwapFunction: INoteSwapFunction = function(updatedItems: MedicalItemRiskFactor[], notesModel: IPatientMedicalNoteModel): IPatientMedicalNoteModel {
            notesModel = notesModel.set("MedicalItemsRiskFactor", Immutable.List(updatedItems));
            return notesModel;
        };

        let summarySwapFunction: ISummarySwapFunction = function(summaryModel: IPatientMedicalSummaryModel): IPatientMedicalSummaryModel {
            let updatedMedicalItems: MedicalItemRiskFactor[] = response.Data.MedicalItems;
            summaryModel = summaryModel.set("MedicalItemsRiskFactor", Immutable.List(updatedMedicalItems));
            return summaryModel;
        };

        this.saveMedicalItem(response, store, patientNoteSwapFunction, summarySwapFunction, MedicalItemTypeEnum.SocialHabitsAndRiskFactors, isSavePlus);
        this.redirectToSummary(isSavePlus);
    }

    private SaveMedicalItemAlert(response: ServerEvent, store: PatientStore, isSavePlus: boolean = false): void {
        let patientNoteSwapFunction: INoteSwapFunction = function(updatedItems: MedicalItemAlertsAndSpecialNeeds[], notesModel: IPatientMedicalNoteModel): IPatientMedicalNoteModel {
            notesModel = notesModel.set("MedicalItemsAlertAndSpecialNeed", Immutable.List(updatedItems));
            return notesModel;
        };

        let summarySwapFunction: ISummarySwapFunction = function(summaryModel: IPatientMedicalSummaryModel): IPatientMedicalSummaryModel {
            let updatedMedicalItems: MedicalItemAlertsAndSpecialNeeds[] = response.Data.MedicalItems;
            summaryModel = summaryModel.set("MedicalItemsAlertAndSpecialNeed", Immutable.List(updatedMedicalItems));
            return summaryModel;
        };

        this.saveMedicalItem(response, store, patientNoteSwapFunction, summarySwapFunction, MedicalItemTypeEnum.AlertsAndSpecialNeeds, isSavePlus);
        this.redirectToSummary(isSavePlus);
    }

    private SaveMedicalItemActiveMedication(response: ServerEvent, store: PatientStore, isSavePlus: boolean = false): void {
        let patientNoteSwapFunction: INoteSwapFunction = function(updatedItems: MedicalItemMedicationAndPrescription[], notesModel: IPatientMedicalNoteModel): IPatientMedicalNoteModel {
            notesModel = notesModel.set("MedicalItemsMedicationAndPrescription", Immutable.List(updatedItems));
            return notesModel;
        };

        let summarySwapFunction: ISummarySwapFunction = function(summaryModel: IPatientMedicalSummaryModel): IPatientMedicalSummaryModel {
            let updatedMedicalItems: MedicalItemMedicationAndPrescription[] = response.Data.MedicalItems;
            summaryModel = summaryModel.set("MedicalItemsActiveMedication", Immutable.List(updatedMedicalItems));
            return summaryModel;
        };

        this.saveMedicalItem(response, store, patientNoteSwapFunction, summarySwapFunction, MedicalItemTypeEnum.MedicationsAndPrescriptions, isSavePlus);
        this.redirectToSummary(isSavePlus);
    }

    private SaveMedicalItemFamilyHistory(response: ServerEvent, store: PatientStore, isSavePlus: boolean = false): void {
        let patientNoteSwapFunction: INoteSwapFunction = function(updatedItems: MedicalItemFamilyHistory[], notesModel: IPatientMedicalNoteModel): IPatientMedicalNoteModel {
            notesModel = notesModel.set("MedicalItemsFamilyHistory", Immutable.List(updatedItems));
            return notesModel;
        };

        let summarySwapFunction: ISummarySwapFunction = function(summaryModel: IPatientMedicalSummaryModel): IPatientMedicalSummaryModel {
            let updatedMedicalItems: MedicalItemFamilyHistory[] = response.Data.MedicalItems;
            summaryModel = summaryModel.set("MedicalItemsFamilyHistory", Immutable.List(updatedMedicalItems));
            return summaryModel;
        };

        this.saveMedicalItem(response, store, patientNoteSwapFunction, summarySwapFunction, MedicalItemTypeEnum.FamilyHistory, isSavePlus);
        this.redirectToSummary(isSavePlus);
    }

    private SaveMedicalItemImmunization(response: ServerEvent, store: PatientStore, isSavePlus: boolean = false): void {
        let patientNoteSwapFunction: INoteSwapFunction = function(updatedItems: MedicalItemImmunization[], notesModel: IPatientMedicalNoteModel): IPatientMedicalNoteModel {
            notesModel = notesModel.set("MedicalItemsImmunization", Immutable.List(updatedItems));
            return notesModel;
        };

        let updatedMedicalItems: MedicalItemImmunization[] = response.Data.MedicalItems;

        let summarySwapFunction: ISummarySwapFunction = function(summaryModel: IPatientMedicalSummaryModel): IPatientMedicalSummaryModel {
            summaryModel = summaryModel.set("MedicalItemsImmunization", Immutable.List(updatedMedicalItems));
            return summaryModel;
        };

        this.saveMedicalItem(response, store, patientNoteSwapFunction, summarySwapFunction, MedicalItemTypeEnum.Immunization, isSavePlus);
        this.redirectToSummary(isSavePlus);
    }

    private SaveMedicalItemVitalSign(response: ServerEvent, store: PatientStore, isSavePlus: boolean = false): void {
        let patientNoteSwapFunction: INoteSwapFunction = function(updatedItems: MedicalItemVitalSign[], notesModel: IPatientMedicalNoteModel): IPatientMedicalNoteModel {
            notesModel = notesModel.set("MedicalItemsVitalSign", Immutable.List(updatedItems));
            return notesModel;
        };

        let summarySwapFunction: ISummarySwapFunction = function(summaryModel: IPatientMedicalSummaryModel): IPatientMedicalSummaryModel {
            let updatedMedicalItems: MedicalItemVitalSign[] = response.Data.MedicalItems;
            summaryModel = summaryModel.set("MedicalItemsVitalSign", Immutable.List(updatedMedicalItems));
            return summaryModel;
        };

        this.saveMedicalItem(response, store, patientNoteSwapFunction, summarySwapFunction, MedicalItemTypeEnum.VitalSigns, isSavePlus);
    }

    private SaveMedicalItemScreeningTest(response: ServerEvent, store: PatientStore, isSavePlus: boolean = false): void {
        let patientNoteSwapFunction: INoteSwapFunction = function(updatedItems: MedicalItemScreeningTestResponse[], notesModel: IPatientMedicalNoteModel): IPatientMedicalNoteModel {
            notesModel = notesModel.set("MedicalItemsScreeningTest", Immutable.List(updatedItems));
            return notesModel;
        };

        let summarySwapFunction: ISummarySwapFunction = function(summaryModel: IPatientMedicalSummaryModel): IPatientMedicalSummaryModel {
            let updatedMedicalItems: MedicalItemScreeningTestResponse[] = response.Data.MedicalItems;
            summaryModel = summaryModel.set("MedicalItemsScreeningTest", Immutable.List(updatedMedicalItems));
            return summaryModel;
        };

        this.saveMedicalItem(response, store, patientNoteSwapFunction, summarySwapFunction, MedicalItemTypeEnum.ScreeningTest, isSavePlus);
        this.redirectToSummary(isSavePlus);
    }

    // ----------------------------
    // --- common -----
    private saveMedicalItem(response: ServerEvent, store: PatientStore, patientNoteSwapFunction: INoteSwapFunction, patientSummarySwapFunction: ISummarySwapFunction, itemType: MedicalItemTypeEnum, isSavePlus: boolean = false): void {
        if (response.hasErrors()) {
            sessionStore.showPopup(response.Errors);
            store.PatientMedicalItemsModels[response.PatientId] = store.PatientMedicalItemsModels[response.PatientId].set("IsSaving", false);
            return;
        }

        if (response.hasWarnings())
            sessionStore.showPopup(response.Warnings);

        let operation = null;
        let patientContactId = response.PatientId;
        let updatedMedicalItems: MedicalItem[] = [];
        let isFromAssessment = response.Data.IsFromAssessment;
        let encounterId: Guid = null;
        let emrTemplateId: string = response.Data.EMRTemplateId;

        switch (itemType) {
            case MedicalItemTypeEnum.AlertsAndSpecialNeeds:
                updatedMedicalItems = response.Data.MedicalItems as MedicalItemAlertsAndSpecialNeeds[];
                break;

            case MedicalItemTypeEnum.FamilyHistory:
                updatedMedicalItems = response.Data.MedicalItems as MedicalItemFamilyHistory[];
                break;

            case MedicalItemTypeEnum.MedicalReaction:
                updatedMedicalItems = response.Data.MedicalItems as MedicalItemMedicalReaction[];
                break;

            case MedicalItemTypeEnum.Immunization:
                updatedMedicalItems = response.Data.MedicalItems as MedicalItemImmunization[];
                break;

            case MedicalItemTypeEnum.MedicationsAndPrescriptions:
                updatedMedicalItems = response.Data.MedicalItemsMedicationAndPrescription as MedicalItemMedicationAndPrescription[];
                break;

            case MedicalItemTypeEnum.PastAndOngoingProblemsAndConditions:
                updatedMedicalItems = response.Data.MedicalItems as MedicalItemProblemAndCondition[];
                break;

            case MedicalItemTypeEnum.SocialHabitsAndRiskFactors:
                updatedMedicalItems = response.Data.MedicalItems as MedicalItemRiskFactor[];
                break;

            case MedicalItemTypeEnum.VitalSigns:
                updatedMedicalItems = response.Data.MedicalItems as MedicalItemVitalSign[];
                break;

            case MedicalItemTypeEnum.ScreeningTest:
                updatedMedicalItems = response.Data.MedicalItems as MedicalItemScreeningTestResponse[];
                break;

            default:
                return;
        }

        let itemsModel = store.PatientMedicalItemsModels[patientContactId];
        let notesModel = store.PatientMedicalNoteModels[patientContactId];
        let summaryModel = store.PatientMedicalSummaryModels[patientContactId];

        itemsModel = itemsModel.set("IsSaving", false);

        // If reloading items was successful
        if (updatedMedicalItems && updatedMedicalItems.length > 0) {
            // ensure we display current employee as contributor to current note
            encounterId = updatedMedicalItems[0].RelatedEncounterId;
            if (encounterId)
                store.updateContributorsEncountersData(response.PatientId, encounterId);

            // update allMedicalItems and displayedMedicalItems
            if (itemsModel) {
                let updatedMedicalItems: MedicalItem[] = response.Data.MedicalItems;
                itemsModel = itemsModel.set("AllMedicalItemsList", Immutable.List(updatedMedicalItems));

                let itemsToDisplay = PatientMedicalSummaryHelper.GetMedicalItemsToDisplay(itemsModel.get("AllMedicalItemsList"), emrTemplateId, encounterId);
                itemsModel = itemsModel.set("MedicalItemsList", Immutable.List(itemsToDisplay));
            }

            if (notesModel)
                notesModel = patientNoteSwapFunction(updatedMedicalItems, notesModel);

            if (summaryModel)
                summaryModel = patientSummarySwapFunction(summaryModel);
        }

        store.PatientMedicalItemsModels[response.PatientId] = itemsModel;
        store.PatientMedicalNoteModels[response.PatientId] = notesModel;
        store.PatientMedicalSummaryModels[response.PatientId] = summaryModel;

        sessionStore.hideGlobalOverlay();

        if (itemType == MedicalItemTypeEnum.MedicationsAndPrescriptions)
            store.ActionsMedicationTab.ReloadMedications(response.PatientId);

        if (!isSavePlus) {
            // redirect to the patient note
            sessionStore.dispatch(LocalPatientOperations.MedicalItems.ReturnToNote);
        }
        else {
            // kickoff new emr template
            switch (itemType) {
                case MedicalItemTypeEnum.AlertsAndSpecialNeeds:
                    operation = new LocalEvent(LocalPatientOperations.MedicalNote.Edit_NewAlertSpecialNeedItem);
                    break;
                case MedicalItemTypeEnum.FamilyHistory:
                    operation = new LocalEvent(LocalPatientOperations.MedicalNote.Edit_NewFamilyHistoryItem);
                    break;
                case MedicalItemTypeEnum.MedicalReaction:
                    operation = new LocalEvent(LocalPatientOperations.MedicalNote.Edit_NewMedicalReactionItem);
                    break;
                case MedicalItemTypeEnum.Immunization:
                    operation = new LocalEvent(LocalPatientOperations.MedicalNote.Edit_NewImmunizationItem);
                    break;
                case MedicalItemTypeEnum.MedicationsAndPrescriptions:
                    operation = new LocalEvent(LocalPatientOperations.MedicalNote.Edit_NewActiveMedication);
                    break;
                case MedicalItemTypeEnum.PastAndOngoingProblemsAndConditions:
                    operation = new LocalEvent(LocalPatientOperations.MedicalNote.Edit_NewMedicalHistoryItem);
                    operation.AddItem("Encounter", notesModel?.get("Encounter"));
                    operation.AddItem("isFromAssessment", isFromAssessment);
                    break;
                case MedicalItemTypeEnum.SocialHabitsAndRiskFactors:
                    operation = new LocalEvent(LocalPatientOperations.MedicalNote.Edit_NewRiskFactorItem);
                    break;
                case MedicalItemTypeEnum.VitalSigns:
                    operation = new LocalEvent(LocalPatientOperations.MedicalNote.Edit_NewVitalSignItem);
                    break;
                case MedicalItemTypeEnum.ScreeningTest:
                    operation = new LocalEvent(LocalPatientOperations.MedicalNote.Edit_NewScreeningTestItem);
                    break;
                default:
                    return;
            }
            LocalEventDispatcher.dispatch(operation);
        }
    }

    private redirectToSummary(isSavePlus: boolean): void {
        if (patientStore.IsMedicalItemFromOutsideNote && !isSavePlus) {
            patientStore.IsMedicalItemFromOutsideNote = false;
            sessionStore.dispatch(LocalPatientOperations.MedicalItems.ReturnToSummary);
        }
    }

    private SaveMedicalItemInNewEncounter(response: ServerEvent): void {
        if (response.hasErrors() || IsNullOrWhiteSpace(response.Data.NewEncounterId))
            return;

        sessionStore.dispatch(LocalPatientOperations.MedicalSummary.EncounterClick, { value: response.Data.NewEncounterId });
    }

    private loadVitalSigns(response: ServerEvent, store: PatientStore): void {
        if (response.hasErrors())
            return;

        let vitalSigns = response.Data?.MedicalItems || [];
        let medicalSummary = store.PatientMedicalSummaryModels[response.PatientId];
        medicalSummary = medicalSummary.set("MedicalItemsVitalSign", Immutable.List(vitalSigns));

        store.PatientMedicalSummaryModels[response.PatientId] = medicalSummary;
    }

    private DeleteMedicalItem(response: ServerEventWithRequest<IMyle_Patient_MedicalItem_DeleteMedicalItem>, store: PatientStore): void {
        if (response.Data.IsSuccess != true) {
            var operation = new LocalEvent(LocalPatientOperations.MedicalItems.CancelRemoveMedicalItem);
            LocalEventDispatcher.dispatch(operation);
            sessionStore.showPopup({
                title: cacheStore.GetString("DeletionFailedLabel"),
                content: response.Errors
            });
            return;
        }

        if (response.requestDto.EncounterId != null)
            store.updateContributorsEncountersData(response.PatientId, response.requestDto.EncounterId);

        let itemsModel = store.PatientMedicalItemsModels[response.PatientId];
        let notesModel = store.PatientMedicalNoteModels[response.PatientId];
        let summaryModel = store.PatientMedicalSummaryModels[response.PatientId];

        let unApprovedMedicalItemIds: string[] = response.Data.unApprovedMedicalItemIds;
        let deletedId = response.requestDto.MedicalItemId;
        let deletedType = response.requestDto.MedicalItemType;

        let filter: (items: Immutable.List<MedicalItem>) => Immutable.List<any> =
            items => {
                if (!items)
                    return [].toImmutable();

                let filteredItems = items.toArray().filter(x => x.MedicalItemId != deletedId);
                if (unApprovedMedicalItemIds) {
                    filteredItems.forEach(mi => {
                        if (unApprovedMedicalItemIds.contains(mi.Id)) {
                            mi.IsCommitted = false;
                            if (mi.CreationDate != null)
                                mi.CommitDate = mi.CreationDate;
                        }
                    });
                }
                return filteredItems.toImmutable();
            };

        let items = itemsModel.get("MedicalItemsList");

        itemsModel = itemsModel.set("MedicalItemToDelete", null);
        itemsModel = itemsModel.set("ShowDeleteMedicalItemConfirmation", false);
        itemsModel = itemsModel.set("MedicalItemsList", filter(items));
        itemsModel = itemsModel.set("AllMedicalItemsList", filter(items));

        // remove trace of medicalitems in items, summary and note model
        switch (deletedType) {
            case MedicalItemTypeEnum.PastAndOngoingProblemsAndConditions:

                if (notesModel) {
                    notesModel = notesModel.set("MedicalItemsProblemsAndDiagnostics", filter(notesModel.get("MedicalItemsProblemsAndDiagnostics")));
                }
                if (summaryModel) {
                    summaryModel = summaryModel.set("MedicalItemsProblemsOnGoing", filter(summaryModel.get("MedicalItemsProblemsOnGoing")));
                    summaryModel = summaryModel.set("MedicalItemsProblemsHistory", filter(summaryModel.get("MedicalItemsProblemsHistory")));
                    summaryModel = summaryModel.set("MedicalItemsSurgeryHistory", filter(summaryModel.get("MedicalItemsSurgeryHistory")));
                    summaryModel = summaryModel.set("MedicalItemsPsychiatricHistory", filter(summaryModel.get("MedicalItemsPsychiatricHistory")));
                    summaryModel = summaryModel.set("MedicalItemsGynecologicalHistory", filter(summaryModel.get("MedicalItemsGynecologicalHistory")));
                }
                break;
            case MedicalItemTypeEnum.AlertsAndSpecialNeeds:
                if (notesModel)
                    notesModel = notesModel.set("MedicalItemsAlertAndSpecialNeed", filter(notesModel.get("MedicalItemsAlertAndSpecialNeed")));
                if (summaryModel)
                    summaryModel = summaryModel.set("MedicalItemsAlertAndSpecialNeed", filter(summaryModel.get("MedicalItemsAlertAndSpecialNeed")));
                break;
            case MedicalItemTypeEnum.FamilyHistory:
                if (notesModel)
                    notesModel = notesModel.set("MedicalItemsFamilyHistory", filter(notesModel.get("MedicalItemsFamilyHistory")));
                if (summaryModel)
                    summaryModel = summaryModel.set("MedicalItemsFamilyHistory", filter(summaryModel.get("MedicalItemsFamilyHistory")));
                break;
            case MedicalItemTypeEnum.Immunization:
                if (notesModel)
                    notesModel = notesModel.set("MedicalItemsImmunization", filter(notesModel.get("MedicalItemsImmunization")));
                if (summaryModel)
                    summaryModel = summaryModel.set("MedicalItemsImmunization", filter(summaryModel.get("MedicalItemsImmunization")));
                break;
            case MedicalItemTypeEnum.MedicalReaction:
                if (notesModel)
                    notesModel = notesModel.set("MedicalItemsMedicalReaction", filter(notesModel.get("MedicalItemsMedicalReaction")));
                if (summaryModel)
                    summaryModel = summaryModel.set("MedicalItemsMedicalReaction", filter(summaryModel.get("MedicalItemsMedicalReaction")));
                break;
            case MedicalItemTypeEnum.SocialHabitsAndRiskFactors:
                if (notesModel)
                    notesModel = notesModel.set("MedicalItemsRiskFactor", filter(notesModel.get("MedicalItemsRiskFactor")));
                if (summaryModel)
                    summaryModel = summaryModel.set("MedicalItemsRiskFactor", filter(summaryModel.get("MedicalItemsRiskFactor")));
                break;
            case MedicalItemTypeEnum.VitalSigns:
                if (notesModel)
                    notesModel = notesModel.set("MedicalItemsVitalSign", filter(notesModel.get("MedicalItemsVitalSign")));
                if (summaryModel)
                    summaryModel = summaryModel.set("MedicalItemsVitalSign", filter(summaryModel.get("MedicalItemsVitalSign")));
                break;
            case MedicalItemTypeEnum.ScreeningTest:
                if (notesModel)
                    notesModel = notesModel.set("MedicalItemsScreeningTest", filter(notesModel.get("MedicalItemsScreeningTest")));
                if (summaryModel)
                    summaryModel = summaryModel.set("MedicalItemsScreeningTest", filter(summaryModel.get("MedicalItemsScreeningTest")));
                break;
            default:
                break;
        }

        store.PatientMedicalItemsModels[response.PatientId] = itemsModel;
        store.PatientMedicalNoteModels[response.PatientId] = notesModel;
        store.PatientMedicalSummaryModels[response.PatientId] = summaryModel;

        sessionStore.hideGlobalOverlay();

        // redirect to patient note
        window.setTimeout(() => sessionStore.dispatch(LocalPatientOperations.MedicalItems.ReturnToNote), 200);
    }

    private handleFollowupStatusUpdated(response: ServerEvent, store: PatientStore): void {
        if (response.hasErrors())
            return;

        let medicalRequestId = response.Data.MedicalRequestId;
        let medicalRequestType = response.Data.MedicalRequestType;
        let statusLookUpId = response.Data.StatusLookupId;
        let completionDate = response.Data.CompletionDate;

        let itemModel = store.PatientMedicalItemsModels[response.PatientId];
        let notesModel = store.PatientMedicalNoteModels[response.PatientId];
        let summaryModel = store.PatientMedicalSummaryModels[response.PatientId];

        if (itemModel)
            itemModel = itemModel
                .set("MedicalItemsList", this.filter(itemModel.get("MedicalItemsList"), medicalRequestId, medicalRequestType, statusLookUpId, completionDate))
                .set("AllMedicalItemsList", this.filter(itemModel.get("AllMedicalItemsList"), medicalRequestId, medicalRequestType, statusLookUpId, completionDate));

        if (notesModel) {
            notesModel = notesModel.set("MedicalItemsScreeningTest", this.filter(notesModel.get("MedicalItemsScreeningTest"), medicalRequestId, medicalRequestType, statusLookUpId, completionDate));
            switch (medicalRequestType) {
                case MedicalRequestType.ConsultationRequest:
                    let consultationRequest = notesModel.get("ConsultationRequests").toArray().firstOrDefault(x => x.ConsultationRequestId == medicalRequestId);
                    if (consultationRequest) {
                        consultationRequest.StatusLookupId = statusLookUpId;
                        notesModel = notesModel.set("ConsultationRequests", notesModel.get("ConsultationRequests").upsert(obj => obj.ConsultationRequestId == medicalRequestId, consultationRequest));
                    }
                    break;
                case MedicalRequestType.LabRequest:
                    let labRequest = notesModel.get("Requests").toArray().firstOrDefault(x => x.RequestId == medicalRequestId);
                    if (labRequest) {
                        labRequest.StatusLookupId = statusLookUpId;
                        notesModel = notesModel.set("Requests", notesModel.get("Requests").upsert(obj => obj.RequestId == medicalRequestId, labRequest));
                    }
                    break;
            }
        }

        if (summaryModel)
            summaryModel = summaryModel
                .set("MedicalItemsScreeningTest", this.filter(summaryModel.get("MedicalItemsScreeningTest"), medicalRequestId, medicalRequestType, statusLookUpId, completionDate))
                .set("FollowUps", this.updateFollowUpComposite(summaryModel.get("FollowUps"), medicalRequestId, medicalRequestType, statusLookUpId, completionDate));
    }

    private filter(items: Immutable.List<MedicalItem>, medicalRequestId: string, medicalRequestType: MedicalRequestType, statuslookupid: string, completiondate: Date): Immutable.List<any> {
        if (!items)
            return [].toImmutable();

        let filteredItems = items.toArray();
        for (let x of filteredItems) {
            if (x.EMRTemplateMedicalItemType !== MedicalItemTypeEnum.ScreeningTest)
                continue;

            let screeningtest = x as MedicalItemScreeningTestResponse;
            if (screeningtest.FollowUps) {
                let followup = screeningtest.FollowUps.firstOrDefault(f => f.Id === medicalRequestId && f.MedicalRequestType === medicalRequestType);
                if (followup) {
                    followup.StatusLookupId = statuslookupid;
                    followup.CompletionDate = completiondate;
                    screeningtest.FollowUps = screeningtest.FollowUps.map(f => (f.Id === followup.Id && f.MedicalRequestType === followup.MedicalRequestType) ? followup : f);
                }
            }
        }
        return filteredItems.toImmutable();
    }

    private updateFollowUpComposite(items: Immutable.List<FollowUpResponse>, medicalRequestId: string, medicalRequestType: MedicalRequestType, statusLookupId: string, completionDate: Date): Immutable.List<FollowUpResponse> {
        if (!items)
            return [].toImmutable();

        let updatedItems = items.toArray();

        updatedItems.mutate(
            f => {
                f.StatusLookupId = statusLookupId;
                f.CompletionDate = completionDate;
            },
            f => f.Id == medicalRequestId && f.MedicalRequestType === medicalRequestType
        );

        return updatedItems.toImmutable();
    }
}

interface IMyle_Patient_MedicalItem_DeleteMedicalItem {
    MedicalItemId: Guid;
    MedicalItemType: MedicalItemTypeEnum;
    EncounterId: Guid;
    LatestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: string;
}

export { IMyle_Patient_MedicalItem_DeleteMedicalItem, PatientMedicalItemsResponseHandler };
